export const AVG_RESPONSE_TIME_FAST = 3;

export const AVG_RESPONSE_TIME_SLOW = 5;

export const MID_RESPONSE_TIME_COLOR = '#F69E05';
